/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setIncomingRequestPolicy} from '../api'

export const useMutationSetIncomingRequestPolicy = createReactQueryMutationHook('setIncomingRequestPolicy', setIncomingRequestPolicy)
